export const PERMISSIONS = {
  DASHBOARD: 'breadstack_dashboard',
  PRODUCTS: 'breadstack_product',
  ORDERS: 'breadstack_order',
  CUSTOMERS: 'breadstack_customer',
  PROMOTIONS: 'breadstack_promotions',
  COUPONS: 'breadstack_coupons',
  ANALYTICS: 'breadstack_insight',
  FULFILLMENT: 'breadstack_fulfillment',
  MEDIA: 'breadstack_media_library',

  CS_DASHBOARD: 'chatso_dashboard',
  LIVE_CHAT: 'chatso_live_chat',
  VISITORS: 'chatso_visitor_tracking',
  CHAT_RECORDS: 'chatso_chat_record',
  CS_TICKET: 'chatso_ticket_management',
  CS_PROMOTIONS: 'chatso_promotion',
  CS_COUPONS: 'chatso_coupons',
  CS_ANALYTICS: 'chatso_insight',

  INVENTORY: 'breadstack_inventory',
  SALES_MANAGE: 'sales_manage',
  SALES_VIEW: 'sales_view',
  SETTINGS: 'settings',

  EMAIL_DASHBOARD: 'breadstack_email_marketing',
  EMAIL_WORKFLOWS: 'breadstack_email_marketing_workflows',
  EMAIL_TEMPLATES: 'breadstack_email_marketing_templates',
  EMAIL_QUEUES: 'breadstack_email_marketing_queues',
  EMAIL_SUBSCRIBERS: 'breadstack_email_marketing_subscribers',
}
